export function dataInRequest(params = {}) {
  return {
    type: '@recebimentoAreiaNf/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@recebimentoAreiaNf/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@recebimentoAreiaNf/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@recebimentoAreiaNf/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@recebimentoAreiaNf/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@recebimentoAreiaNf/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@recebimentoAreiaNf/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@recebimentoAreiaNf/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@recebimentoAreiaNf/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@recebimentoAreiaNf/RECORD_FILTERING',
    payload: { params },
  };
}
